/* Lucky Cosmos phone layer for Cowboy Killer Boot Co. (Relic preset of Fit Check).
   Loaded once from layout/theme.liquid, right after assets/lc-mobile.css.

   Swipe nudge, phones only (749px and below): every "Features carousel" section
   (cards-feature-carousel, on the homepage and the Fit Guide, and any added later)
   slides about 70px to the side and back once, the first time it comes into view,
   so visitors can see the cards swipe. It plays once per carousel per page view,
   stops if the visitor touches that carousel, and never plays for visitors who have
   reduced motion turned on. Same behavior as the Round Top Finds swipe nudge.
   To undo: delete this file and its line in layout/theme.liquid. */
(function () {
  'use strict';
  var PHONE = window.matchMedia('(max-width: 749px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var TRACKS = '.fc-cards-carousel carousel-slides';

  function nudge(el) {
    if (el.dataset.lcTouched || REDUCED.matches || !PHONE.matches || el.scrollWidth <= el.clientWidth + 4) return;
    var start = el.scrollLeft;
    var dist = Math.min(72, el.clientWidth * 0.18);
    var snap = el.style.scrollSnapType, beh = el.style.scrollBehavior;
    var t0 = null, dur = 1100;
    el.style.scrollSnapType = 'none';
    el.style.scrollBehavior = 'auto';
    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function restore() { el.scrollLeft = start; el.style.scrollSnapType = snap; el.style.scrollBehavior = beh; }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var k = p < 0.45 ? ease(p / 0.45) : 1 - ease((p - 0.45) / 0.55);
      if (el.dataset.lcTouched) { el.style.scrollSnapType = snap; el.style.scrollBehavior = beh; return; }
      el.scrollLeft = start + dist * k;
      if (p < 1) requestAnimationFrame(step); else restore();
    }
    requestAnimationFrame(step);
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting || e.intersectionRatio < 0.6 || e.target.dataset.lcNudged) return;
      e.target.dataset.lcNudged = '1';
      io.unobserve(e.target);
      setTimeout(function () { nudge(e.target); }, 450);
    });
  }, { threshold: [0.6] }) : null;

  /* Only touching this carousel cancels its nudge. Scrolling down the page is a touch too,
     so a page-wide listener would stop the nudge before it ever played. */
  function watchTouch(track) {
    if (track.dataset.lcWatch) return;
    track.dataset.lcWatch = '1';
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { track.dataset.lcTouched = '1'; }, { passive: true });
    });
  }

  function init(root) {
    (root || document).querySelectorAll(TRACKS).forEach(function (track) {
      watchTouch(track);
      if (io && !track.dataset.lcNudged) io.observe(track);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
